import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b6aad662"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slideright"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, "px", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createBlock(_component_el_form_item, null, {
    label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.title), 1)]),
    default: _withCtx(() => [_createVNode(_component_el_slider, {
      modelValue: $data.sliderNumber,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.sliderNumber = $event),
      onInput: $options.sliderChange
    }, null, 8, ["modelValue", "onInput"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input_number, {
      modelValue: $data.inputNumber,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.inputNumber = $event),
      "controls-position": "right",
      onChange: $options.inputChange
    }, null, 8, ["modelValue", "onChange"]), _hoisted_2])]),
    _: 1
  });
}